import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import AddBlog from "./addBlog";
import { fetchBlogs } from "store/actions/blogActions";
import { useDispatch, useSelector } from "react-redux";
import { deleteBlog } from "store/actions/blogActions";
import TableComponent from "components/TableComponent";
import TabsInfoModal from "components/Modal/TabsInfoModal";

const Blogs = () => {
  const dispatch = useDispatch();
  const [addBlog, setAddBlog] = useState(false);
  const { blogs, hasMoreBlogs, lastBlogDocument } = useSelector(
    (state) => state.blog
  );
  const [editingBlogId, setEditingBlogId] = useState(null);
  const [blog, setBlog] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loader, setLoader] = useState({
    data: false,
    loadMore: false,
  });
  const infoPoints = [
    "In the News module, the admin can create, post, update, and delete blog entries.",
  ];
  const subPoints = [];
  const infoTitle = "News Information";
  const [infoModalOpen, setInfoModalOpen] = useState(false);
  const columns = ["Title", "Description", "Created At", "Image"];
  const keyMap = {
    Title: "title",
    Description: "description",
    "Created At": "createdAt",
    Image: "imageUrl",
  };

  const formattedData = blogs?.map((blog) => ({
    ...blog,
    createdAt: new Date(blog.created_at?.seconds * 1000).toLocaleString(),
    description: (
      <div
        className="blogDescription"
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(blog.description) }}
      />
    ),
    imageUrl: blog.imageUrl ? (
      <img src={blog.imageUrl} width={50} height={50} alt="blog" />
    ) : (
      "N/A"
    ),
  }));

  const handleEdit = (id) => {
    setAddBlog(true);
    setEditingBlogId(id);
    setBlog({
      ...blog,
      description: blog.description ? blog.description.toString() : "",
    });
  };

  const handleDelete = (blog) => {
    setBlog(blog);
    setShowModal(true);
  };
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      fetchBlogs("", () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  const loadMoreBlogs = () => {
    setLoader((prev) => ({
      ...prev,
      loadMore: true,
    }));
    dispatch(
      fetchBlogs(lastBlogDocument, () => {
        setLoader((prev) => ({
          ...prev,
          loadMore: false,
        }));
      })
    );
  };

  const renderActions = (row) => {
    return (
      <>
        <Button
          onClick={() => {
            const blog = blogs.find((el) => el.id === row.id);
            handleEdit(blog);
          }}
          size="sm"
          className="bg-primary border-0 text-white"
        >
          Edit
        </Button>
        <Button
          onClick={() => {
            const blog = blogs.find((el) => el.id === row.id);
            handleDelete(blog);
          }}
          size="sm"
          className="bg-danger border-0 text-white"
        >
          Delete
        </Button>
      </>
    );
  };

  return (
    <>
      <Header />
      {!addBlog ? (
        <Container className="mt-2" fluid>
          <Row>
            <div className="col">
              <Card className="shadow py-2">
                <CardHeader className="border-0 justify-content-end d-flex flex-wrap align-items-center px-2 px-sm-3">
                  <Button
                    className="bg-primary border-0 text-white"
                    onClick={() => {
                      setAddBlog(true);
                    }}
                  >
                    Add Post
                  </Button>
                  <h2
                    className="mb-0 text-primary"
                    style={{ cursor: "pointer" }}
                    onClick={() => setInfoModalOpen(true)}
                  >
                    <i className="fa fa-question-circle" aria-hidden="true"></i>
                  </h2>{" "}
                </CardHeader>
                {loader.data ? (
                  <div className="text-center mt-4">
                    <Spinner color="primary" />
                  </div>
                ) : (
                  <TableComponent
                    columns={columns}
                    data={formattedData}
                    keyMap={keyMap}
                    renderActions={renderActions}
                  />
                )}
                {blogs.length > 4 && (
                  <div className="text-center py-4">
                    <Button
                      color="primary"
                      onClick={loadMoreBlogs}
                      disabled={loader.loadMore || !hasMoreBlogs}
                    >
                      {loader.loadMore ? <Spinner size="sm" /> : "Load More"}{" "}
                    </Button>
                  </div>
                )}
              </Card>
            </div>
          </Row>
        </Container>
      ) : (
        <AddBlog
          setAddBlog={setAddBlog}
          editingBlogId={editingBlogId}
          setEditingBlogId={setEditingBlogId}
        />
      )}
      <TabsInfoModal
        setInfoModalOpen={setInfoModalOpen}
        infoModalOpen={infoModalOpen}
        data={infoPoints}
        title={infoTitle}
        subPoints={subPoints}
      />
      <Modal isOpen={showModal} centered>
        <ModalBody>
          <div className="text-center">
            <br />
            <br />
            <span className="mt-2" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-2" style={{ fontSize: 16 }}>
              You want to delete.
            </span>
            <br />
            <br />
            <br />
            <Button
              color="primary"
              onClick={() => {
                setIsDeleting(true);
                dispatch(
                  deleteBlog(blog, () => {
                    setIsDeleting(false);
                    setShowModal(false);
                  })
                );
              }}
              disabled={isDeleting}
            >
              {isDeleting ? <Spinner size="sm" /> : "Yes"}
            </Button>
            <Button color="danger" onClick={() => setShowModal(false)}>
              No
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Blogs;
